import { userSlice } from '../slices/userSlice';

export default userSlice.reducer;
